<button
  class="copy-btn"
  type="button"
  [class.copy-btn-copied]="isCopied()"
  [attr.aria-label]="(isCopied() ? 'copy-button.copied' : 'copy-button.copy') | translate"
  (click)="copy()"
>
  <tc-icon class="copy-btn-icon" [name]="isCopied() ? 'check' : 'copy'" />
  <span class="copy-btn-label">{{ (isCopied() ? 'copy-button.copied' : 'copy-button.copy') | translate }}</span>
</button>
